import Swiper, {Pagination} from "swiper";

export default () => {

    document.querySelectorAll('.super-sect__slider').forEach((slider) => {

        new Swiper(slider, {
            modules: [Pagination],
            wrapperClass: 'slider__slides',
            slideClass: 'slider__slide',
            slidesPerView: 1,
            pagination: {
                el: slider.querySelector('.slider__pagination')
            },
            breakpoints: {
                767: {
                    slidesPerView: 2
                }
            }
        });

    });

}